// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SetUnifiedGroupLastVisitedTimeJsonRequest from "../contract/SetUnifiedGroupLastVisitedTimeJsonRequest";

export default function setUnifiedGroupLastVisitedTimeJsonRequest(data: SetUnifiedGroupLastVisitedTimeJsonRequest): SetUnifiedGroupLastVisitedTimeJsonRequest {
    const result: SetUnifiedGroupLastVisitedTimeJsonRequest = {
        __type: "SetUnifiedGroupLastVisitedTimeJsonRequest:#Exchange",
        ...data,
    };
    
    return result;
}
